import { useUser } from '@context/contexts';
import "@css/Ranks.css";

// Таблица наград за серии ежедневных ачивок,
// общая для страницы "Звания" (/ranks/) и раздела "Для родителей"
export const StreaksTable = () => {
    const { preferences } = useUser();
    const dailyStreaks = preferences?.siteSettings?.dailyStreaks;

    return (
        <div className="status">
            <h2>Награды за серию целей</h2>
            {dailyStreaks && dailyStreaks.length > 0 ? (
                <table className="streaks-table">
                    <thead>
                        <tr className="streaks-head">
                            <th className="streaks-th">Дни</th>
                            <th className="streaks-th">Награда</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dailyStreaks.map((streak) => (
                            <tr key={streak?.days} className="streaks-row">
                                <td className="streaks-td">{streak?.days}</td>
                                <td className="streaks-td">{streak?.rewardAmount || 0}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <div className="rank_info">Нет награды за серии</div>
            )}
        </div>
    );
};

// Таблица званий/целей/наград + таблица наград за серии,
// общая для страницы "Звания" (/ranks/) и раздела "Для родителей"
const RanksLevelsTable = () => {
    const { levels } = useUser();

    const ranks = levels.map((x, i) => {
        const rangeEnd = i < levels.length - 1 ? `- ${levels[i + 1].rating - 1}` : '+';
        return {
            info: `${x.name} (хотя бы один рейтинг) Супер${x.name} (все рейтинги)`,
            title: `${x.rating} ${rangeEnd}`,
            img: `${x.id}-white`,
            target: `Цель: Задач: ${x.dailyTargets?.puzzles ?? 0}, Игр: ${x.dailyTargets?.games ?? 0}`,
            reward: `Награда за ежедневную цель: ${x.dailyReward?.amount ?? 0}`,
        };
    });

    return (
        <>
            <div className="rating-ranks">
                {ranks.map((rank) => (
                    <div key={rank.img} className="ranks_item">
                        <div className="ranki2">
                            <img src={`/images/${rank.img}.png`} alt={rank.img} style={{ pointerEvents: "none", cursor: "default" }} />
                        </div>
                        <div className="rank_title">{rank.title}</div>
                        <div className="rank_info">{rank.info}</div>
                        <div className="rank_target">{rank.target}</div>
                        <div className="rank_target">{rank.reward}</div>
                    </div>
                ))}
            </div>

            <StreaksTable />
        </>
    );
};

export default RanksLevelsTable;
